import { IData } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataData: IData = {
  selectSenderRules: [
    { order: 0, positionPrefix: 'dek-1', country: 'PT', sender: 'AT-Zufall' },
    { order: 1, positionPrefix: '', country: '*', sender: 'SAM' },
  ],
  expressOrdersMonthlyLimitReached: false,
  pricesHistory: {
    PALLETS: [
      {
        userRole: 'BERNHARD',
        createdBy: 'BERNHARD',
        id: 'awefhiowjefoia',
        updatedBy: 'BERNHARD',
        price: 100,
        createdAt: timestampMockHelpers.tenMinutesEarlier,
        updatedAt: timestampMockHelpers.tenMinutesEarlier,
      },
      {
        userRole: 'BERNHARD',
        createdBy: 'BERNHARD',
        id: 'awefhiowjefoia',
        updatedBy: 'BERNHARD',
        price: 90,
        createdAt: timestampMockHelpers.oneWeekEarlier,
        updatedAt: timestampMockHelpers.oneWeekEarlier,
      },
      {
        userRole: 'BERNHARD',
        createdBy: 'BERNHARD',
        id: 'awefhiowjefoia',
        updatedBy: 'BERNHARD',
        price: 85,
        createdAt: timestampMockHelpers.eightMonthsEarlier,
        updatedAt: timestampMockHelpers.eightMonthsEarlier,
      },
      {
        userRole: 'BERNHARD',
        createdBy: 'BERNHARD',
        id: 'awefhiowjefoia',
        updatedBy: 'BERNHARD',
        price: 80,
        createdAt: timestampMockHelpers.oneYearEarlier,
        updatedAt: timestampMockHelpers.oneYearEarlier,
      },
    ],
    UK: [],
  },
  paymentsPerMonth: [
    {
      NOVEMBER: {
        openAmounts: {
          TOTAL: 33800,
          EUROPE: 33800,
        },
        paidAmounts: {
          TOTAL: 20200,
          EUROPE: 20200,
        },
        totalAmounts: {
          TOTAL: 54000,
          EUROPE: 54000,
        },
        percentages: {
          TOTAL: 37.41,
          EUROPE: 37.41,
        },
        payments: [],
        year: 2025,
      },
    },
    {
      OCTOBER: {
        openAmounts: {
          TOTAL: 0,
          EUROPE: 0,
          OTHER: 0,
        },
        paidAmounts: {
          TOTAL: 129800,
          EUROPE: 112500,
          OTHER: 17300,
        },
        totalAmounts: {
          TOTAL: 129800,
          EUROPE: 112500,
          OTHER: 17300,
        },
        percentages: {
          TOTAL: 100,
          EUROPE: 100,
          OTHER: 100,
        },
        payments: [
          {
            amount: 100000,
            area: 'EUROPE',
            date: 1763909953,
            location: 'Tresor',
          },
          {
            amount: 10000,
            area: 'EUROPE',
            date: 1763916658,
            location: 'Wien',
          },
          {
            amount: 2500,
            area: 'EUROPE',
            date: 1763916726,
            location: 'Genf',
          },
          {
            amount: 17300,
            area: 'OTHER',
            date: 1763916726,
            location: 'Genf',
          },
        ],
        year: 2025,
      },
    },
  ],
  availablePositions: [
    {
      id: 'kleine-kapseln-40g',
      userRole: 'SAM',
      createdBy: 'BERNHARD',
      updatedBy: 'BERNHARD',
      createdAt: timestampMockHelpers.tenMinutesEarlier,
      updatedAt: timestampMockHelpers.now,
      title: { de: 'Kleine Kapseln 40g', en: 'Small Capsules 40g' },
      minAmount: 5,
    },
    {
      id: 'große-kapseln-120g',
      userRole: 'EVA',
      createdBy: 'BERNHARD',
      updatedBy: 'BERNHARD',
      createdAt: timestampMockHelpers.tenMinutesEarlier,
      updatedAt: timestampMockHelpers.now,
      title: { de: 'Große Kapseln 120g', en: 'Large Capsules 120g' },
      minAmount: 10,
    },
    {
      id: 'kleine-kapseln-400g',
      userRole: 'SAM',
      createdBy: 'BERNHARD',
      updatedBy: 'BERNHARD',
      createdAt: timestampMockHelpers.tenMinutesEarlier,
      updatedAt: timestampMockHelpers.now,
      title: { de: 'Kleine Kapseln 400g', en: 'Small Capsules 400g' },
      minAmount: 5,
    },
    {
      id: 'große-kapseln-555g',
      userRole: 'EVA',
      createdBy: 'BERNHARD',
      updatedBy: 'BERNHARD',
      createdAt: timestampMockHelpers.tenMinutesEarlier,
      updatedAt: timestampMockHelpers.now,
      title: { de: 'Große Kapseln 555g', en: 'Large Capsules 555g' },
      minAmount: 10,
    },
    {
      id: 'palette-800-100',
      userRole: 'SAM',
      createdBy: 'BERNHARD',
      updatedBy: 'BERNHARD',
      createdAt: timestampMockHelpers.tenMinutesEarlier,
      updatedAt: timestampMockHelpers.now,
      title: { de: 'Palette 800x100', en: 'Palette 800x100' },
      minAmount: 1,
    },
  ],
  availablePositionIdsForOrders: ['kleine-kapseln-40g', 'große-kapseln-120g'],
  availablePositionIdsForPreorders: ['kleine-kapseln-400g', 'große-kapseln-555g'],
};
